import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';

import { UsersToolbar, UsersTable } from './components';
import { mockData }  from './data';

 const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    marginTop: "50px",
  },
  content: {
    marginTop: theme.spacing(2)
  }
}));

export const UserList = () => {
  const classes = useStyles();

  const [users] = useState([]);

  return (
    <div className={classes.root}>
      <UsersToolbar />
      <div className={classes.content}>
        <UsersTable users={users} />
      </div>
    </div>
  );
};
